module.exports = __webpack_public_path__ + "static/media/banner.1a2ef88c.png";